import script from "./AngelLeagueInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AngelLeagueInfo.vue?vue&type=script&lang=ts&setup=true"

import "./AngelLeagueInfo.vue?vue&type=style&index=0&id=5e90444e&lang=css"

const __exports__ = script;

export default __exports__